import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Clock, Mail, MessageCircle,
  Phone, Calendar, Lock, Users, Trophy, Zap, AlertTriangle, Globe
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo13 from "@assets/logos_extracted/13.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://alcw.monvaki.com/?mid=282906_1667062";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Štědré bonusové nabídky",
  "Obrovský výběr her od desítek předních poskytovatelů",
  "Poutavý sci-fi design s unikátním systémem hrdinů a gamifikací",
  "Zákaznická podpora 24/7 a web v češtině",
  "Široká škála platebních metod včetně karet, e-peněženek a kryptoměn",
];

const cons = [
  "Nenabízí sportovní sázení",
  "Licence z Curaçaa (méně přísná regulace než EU licence)",
  "Nižší výběrové limity pro nové hráče",
  "Podpora může být někdy pomalejší",
  "Omezené nástroje zodpovědného hraní",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-48 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč (500 Kč pro uvítací bonus)</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>500 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Denní limit výběru:</span><span className={valueClass}>12 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Měsíční limit výběru:</span><span className={valueClass}>168 000 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>E-peněženky a krypto:</span><span className={valueClass}>Okamžitě po schválení</span></div>
        <div className={rowClass}><span className={labelClass}>Karty / banky:</span><span className={valueClass}>1–3 pracovní dny</span></div>
        <div className={rowClass}><span className={labelClass}>Metody vkladu:</span><span className={valueClass}>Visa, Mastercard, Skrill, Neteller, ecoPayz, Trustly, Revolut, Klarna, Jeton, MiFinity, Paysafecard, CashtoCode, eZeeWallet, Bitcoin, Ethereum, Litecoin, Ripple a další</span></div>
        <div className={rowClass}><span className={labelClass}>Metody výběru:</span><span className={valueClass}>Většina vkladových metod (kromě anonymních poukázek)</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>4 000+</span></div>
        <div className={rowClass}><span className={labelClass}>Hrací automaty:</span><span className={valueClass}>Tisíce online automatů včetně exkluzivních titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Ruleta:</span><span className={valueClass}>Evropská, americká, francouzská, RNG i live</span></div>
        <div className={rowClass}><span className={labelClass}>Blackjack:</span><span className={valueClass}>Klasický, Multihand, VIP a další</span></div>
        <div className={rowClass}><span className={labelClass}>Live kasino:</span><span className={valueClass}>Ano – Evolution, Pragmatic Play Live a další</span></div>
        <div className={rowClass}><span className={labelClass}>Turnaje:</span><span className={valueClass}>Desítky turnajů a denní výzvy</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>Play'n GO, NetEnt, Pragmatic Play, Evolution, Microgaming, Playtech, Red Tiger, Quickspin, Push Gaming, Yggdrasil, Thunderkick, EGT a další</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Live chat:</span><span className={valueClass}>Ano – 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@alfcasino.com</span></div>
        <div className={rowClass}><span className={labelClass}>Telefon:</span><span className={valueClass}>Ano – dostupný</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Ano – plná podpora</span></div>
        <div className={rowClass}><span className={labelClass}>Podporované jazyky:</span><span className={valueClass}>Čeština, angličtina, němčina, francouzština, italština, ruština, polština, norština, finština, portugalština a další</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2018</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Rabidi N.V.</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Curaçao eGaming + Anjouan</span></div>
        <div className={rowClass}><span className={labelClass}>Platforma:</span><span className={valueClass}>PC, mobilní prohlížeče (plně responzivní web)</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky webu:</span><span className={valueClass}>Více než 16 včetně češtiny</span></div>
        <div className={rowClass}><span className={labelClass}>VIP program:</span><span className={valueClass}>5 úrovní – cashback, vyšší limity, osobní manažer</span></div>
        <div className={rowClass}><span className={labelClass}>Gamifikace:</span><span className={valueClass}>Systém hrdinů, levelování, odměny</span></div>
        <div className={rowClass}><span className={labelClass}>Přijímané měny:</span><span className={valueClass}>Kč, USD, CAD, NOK, PLN, HUF, INR, JPY, BRL a další</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Deposit limity:", "Denní, týdenní a měsíční nastavení"],
      ["Sebevyloučení:", "Ano"],
      ["Věková hranice:", "18+"],
      ["KYC ověření:", "Povinné před výběrem"],
      ["Nástroje:", "Omezené – méně než u licencovaných EU kasin"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className="flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0">
            <span className="text-gray-500 text-sm sm:w-48 flex-shrink-0">{label}</span>
            <span className="text-gray-900 text-sm font-medium leading-relaxed">{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function AlfCasinoPage() {
  useSEO({ title: "Alf Casino Recenze 2026 – Bonus, hry a hodnocení | HrajBonus", description: "Nezávislá recenze Alf Casino. Sci-fi gamifikace, uvítací bonus, 4000+ slotů od top providerů a výplaty do 24 hodin. Hodnocení 8.9/10. 18+",
  url: "https://hrajbonus.com/kasina/alf-casino", });

  const [activeTab, setActiveTab] = useState("platby");

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo13} alt="Alf Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Recenze Kasina Alf Casino</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",       value: "4 000+" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Minimální výběr", value: "500 Kč" },
                    { label: "Web v češtině",   value: "Ano" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">
                    Sci-fi gamifikace
                  </span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">
                    Non-sticky bonus
                  </span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">
                    VIP 5 úrovní
                  </span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">
                    Wager 35×
                  </span>
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky · Web dostupný v češtině
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus (non-sticky)</div>
                  <div className="text-white font-black text-2xl leading-tight">až 20 000 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 300 free spinů</div>
                  <div className="text-white/50 text-xs mt-1">Wager bonus 35× · Wager FS 40× · Min. vklad 500 Kč</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Alf Casino" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.0</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Recenze Alf Casino</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Alf Casino zaujme hned při prvním pohledu svým sci-fi designem a unikátním systémem gamifikace. Jde o kasino, které nabízí nejen tisíce her od předních světových poskytovatelů, ale i propracovaný věrnostní systém s pěti VIP úrovněmi, cashbackem a osobním manažerem pro nejvěrnější hráče. Svoji hodnotu umocňuje plnou českou lokalizací, telefonickou podporou a non-sticky bonusy.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* About */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">Alf Casino – sci-fi svět s gamifikací</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Alf Casino, spuštěné v roce 2018 pod hlavičkou Rabidi N.V., se odlišuje od konkurence svým poutavým sci-fi tématem a propracovaným systémem gamifikace. Hráč si vybírá hrdinu, sbírá zkušenosti, leveluje a získává odměny – to vše navíc k běžnému kasino zážitku.
                </p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                  {[
                    { label: "Sci-fi téma",         desc: "Systém hrdinů, levelování, odměny za hraní" },
                    { label: "Tisíce her",           desc: "4 000+ titulů od desítek světových poskytovatelů" },
                    { label: "VIP program",          desc: "5 úrovní s cashbackem a osobním manažerem" },
                    { label: "Kryptoměny",           desc: "Bitcoin, Ethereum, Litecoin, Ripple a další" },
                    { label: "Rychlé výběry",        desc: "E-peněženky a krypto okamžitě po schválení" },
                    { label: "Věrnostní systém",     desc: "Moderní rozhraní s gamifikovanými odměnami" },
                  ].map(({ label, desc }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-1">{label}</div>
                      <div className="text-gray-600 text-xs leading-relaxed">{desc}</div>
                    </div>
                  ))}
                </div>
                <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Alf Casino funguje na základě licencí Curaçao eGaming a Anjouan. Obě licence zaručují soulad s mezinárodními standardy, avšak mají nižší přísnost regulace než EU licence (MGA, UKGC). Z pohledu českého práva nejde o operátora s národní licencí Ministerstva financí ČR.
                  </p>
                </div>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hry &amp; Poskytovatelé</h2>
                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  {[
                    ["Celkový počet her",     "4 000+"],
                    ["Hrací automaty",        "Tisíce online automatů včetně exkluzivních titulů"],
                    ["Ruleta",                "Evropská, americká, francouzská, RNG i live"],
                    ["Blackjack",             "Klasický, Multihand, VIP a další"],
                  ].map(([label, val]) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-600 text-xs">{val}</div>
                    </div>
                  ))}
                </div>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-xs mb-2">Populární poskytovatelé</div>
                  <div className="flex flex-wrap gap-1.5">
                    {["Play'n GO", "NetEnt", "Pragmatic Play", "Evolution", "Microgaming", "Playtech", "Red Tiger", "Quickspin", "Push Gaming", "Yggdrasil", "Thunderkick", "EGT"].map(provider => (
                      <span key={provider} className="bg-white border border-[#003da5]/15 text-gray-700 text-xs px-2.5 py-1 rounded-full font-medium">
                        {provider}
                      </span>
                    ))}
                    <span className="text-gray-400 text-xs self-center">a další...</span>
                  </div>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy &amp; Akce</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Alf Casino se pyšní štědrým uvítacím balíčkem ve formě <strong>non-sticky (nelepivého) bonusu</strong>. To znamená, že si hráč může vybrat výhry, aniž by čekal na splnění celého wageru – reálné výhry jsou odděleny od bonusových prostředků.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mb-5">
                  <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                    <div className="text-[#003da5] font-black text-lg mb-0.5">Casino bonus</div>
                    <div className="text-gray-900 font-bold text-base mb-1">100% až 20 000 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm mb-1">+ 200 free spinů + 1 Bonus Crab</div>
                    <div className="text-gray-400 text-xs">Non-sticky · Wager 35× · Min. vklad 500 Kč</div>
                  </div>
                  <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-4">
                    <div className="text-gray-700 font-bold text-base mb-1">Free spiny</div>
                    <div className="text-gray-900 font-bold text-lg mb-1">300 FS</div>
                    <div className="text-gray-400 text-xs">Wager 40×</div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-4">
                  <div className="font-bold text-green-800 text-sm mb-1.5">Co je non-sticky bonus?</div>
                  <p className="text-green-700 text-sm leading-relaxed">
                    Typ bonusu: Non-sticky (nelepivý). U nelepivých bonusů jsou reálné výhry odděleny od bonusových prostředků. Pokud vyhrajete ze svého vlastního vkladu ještě před splněním wageru, můžete si tyto reálné výhry vybrat. Jde o výrazně hráč-přívětivější podmínky než u klasického sticky bonusu.
                  </p>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">VIP program – 5 úrovní</div>
                  <div className="grid grid-cols-5 gap-2">
                    {["Bronz", "Stříbro", "Zlato", "Platina", "Diamant"].map((level, i) => (
                      <div key={level} className={`rounded-lg p-2 text-center text-xs font-semibold ${
                        i === 4 ? "bg-[#003da5] text-white" :
                        i === 3 ? "bg-[#003da5]/70 text-white" :
                        i === 2 ? "bg-[#f5c518] text-gray-900" :
                        i === 1 ? "bg-gray-300 text-gray-700" :
                        "bg-[#cd7f32]/30 text-gray-700"
                      }`}>
                        {level}
                      </div>
                    ))}
                  </div>
                  <div className="mt-3 space-y-1">
                    {[
                      "Cashback dle dosažené VIP úrovně",
                      "Vyšší výběrové limity pro pokročilé hráče",
                      "Osobní VIP manažer u nejvyšších úrovní",
                    ].map(item => (
                      <div key={item} className="flex items-center gap-1.5 text-gray-600 text-xs">
                        <CheckCircle className="w-3.5 h-3.5 text-[#003da5] flex-shrink-0" /> {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Platforms */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Dostupné platformy a mobilní hraní</h2>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">PC a desktop</div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Plně funkční webové rozhraní na všech moderních prohlížečích. Rychlé načítání her, přehledná navigace.
                    </p>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Mobilní prohlížeče</div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Plně responzivní web – není potřeba žádná aplikace. Funguje na Androidu i iOS bez nutnosti stahování.
                    </p>
                  </div>
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební informace</h2>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
                  {[
                    { label: "Min. vklad (obecný)",  value: "250 Kč" },
                    { label: "Min. vklad (bonus)",   value: "500 Kč" },
                    { label: "Min. výběr",           value: "500 Kč" },
                    { label: "Denní výběr",          value: "12 000 Kč" },
                    { label: "Měsíční výběr",        value: "168 000 Kč" },
                    { label: "E-peněženky/krypto",   value: "Okamžitě" },
                    { label: "Karty/banky",          value: "1–3 prac. dny" },
                    { label: "Poplatky kasina",      value: "Standardně žádné" },
                  ].map(({ label, value }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-900 font-bold text-xs leading-tight">{value}</div>
                    </div>
                  ))}
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {["Visa", "Mastercard", "Skrill", "Neteller", "ecoPayz", "Trustly", "Revolut", "Klarna", "Jeton", "MiFinity", "Paysafecard", "CashtoCode", "eZeeWallet", "Bitcoin", "Ethereum", "Litecoin", "Ripple"].map(method => (
                      <PaymentLogoPill key={method} name={method} />
                    ))}
                  </div>
                </div>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Alf Casino nabízí zákaznickou podporu dostupnou 24/7, přičemž čeština je plně podporovaným jazykem. Na rozdíl od většiny kasin v našem přehledu nabízí i telefonickou linku.
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7 – na webu</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@alfcasino.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Phone className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Telefon</div>
                      <div className="text-green-600 text-xs">Dostupný</div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-3">
                  <p className="text-[#003da5] text-xs font-medium">
                    Podporované jazyky: čeština, angličtina, němčina, francouzština, italština, ruština, polština, norština, finština, portugalština a další.
                  </p>
                </div>
              </div>

              {/* Responsible gaming */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zodpovědné hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Alf Casino nabízí základní nástroje pro zodpovědné hraní. Patří mezi ně možnost nastavení deposit limitů a sebevyloučení. Oproti EU licencovaným kasinům jsou tyto nástroje méně rozsáhlé.
                </p>
                <div className="grid sm:grid-cols-3 gap-2">
                  {[
                    "Nastavení vkladových limitů (denní/týdenní/měsíční)",
                    "Dočasné a trvalé sebevyloučení",
                    "Věková hranice 18+",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 bg-[#f3f6fb] rounded-xl p-3">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700 text-xs leading-relaxed">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo13} alt="Alf Casino" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Alf Casino</div>
                      <div className="flex items-center gap-0.5">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus (non-sticky)</div>
                    <div className="text-[#003da5] font-black text-xl">až 20 000 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 300 free spinů</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 35× bonus · 40× FS</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,    label: "Rok",             value: "2018" },
                      { icon: Globe,       label: "Provozovatel",    value: "Rabidi N.V." },
                      { icon: Lock,        label: "Licence",         value: "Curaçao + Anjouan" },
                      { icon: Gamepad2,    label: "Počet her",       value: "4 000+" },
                      { icon: CreditCard,  label: "Min. vklad",      value: "250 Kč (500 Kč pro bonus)" },
                      { icon: Zap,         label: "Výplaty",         value: "Krypto/e-peněženky ihned" },
                      { icon: Trophy,      label: "VIP program",     value: "5 úrovní" },
                      { icon: Users,       label: "Jazyk",           value: "Čeština – plná podpora" },
                      { icon: Phone,       label: "Telefon",         value: "Ano" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <div className="font-bold text-green-800 text-xs mb-1.5">Non-sticky bonus – co to znamená?</div>
                  <p className="text-green-700 text-xs leading-relaxed">
                    Výhry ze skutečných peněz jsou odděleny od bonusu. Pokud vyhrajete ze svého vkladu, můžete si výhry vybrat hned – bez nutnosti čekat na splnění celého wageru.
                  </p>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="alf-casino" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/wazamba" className="text-[#003da5] hover:underline" data-testid="review-link-wazamba">Wazamba</a>
              {" · "}
              <a href="/kasina/sg-casino" className="text-[#003da5] hover:underline" data-testid="review-link-sg-casino">SG Casino</a>
              {" · "}
              <a href="/kasina/stone-vegas" className="text-[#003da5] hover:underline" data-testid="review-link-stone-vegas">Stone Vegas</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
